import { Link } from 'react-router';
import type { Idioma } from '../../../i18n/index.js';
import { AUTORES_EDITORES } from '../autoresEditores.js';
import { CONTACTO } from '../legal.js';

export function AutoresEditoresPage({ idioma }: { readonly idioma: Idioma }) {
  const t = AUTORES_EDITORES[idioma];
  return (
    <main className='mx-auto flex w-full max-w-[820px] grow flex-col gap-10 px-6 py-12'>
      <header>
        <h1 className='m-0 font-(family-name:--serif) text-[36px] leading-tight font-bold sm:text-[42px]'>{t.titulo}</h1>
        <p className='mt-5 mb-3 text-[21px] leading-snug text-(--teal-deep)'>{t.entrada}</p>
        <p className='m-0 text-[16px] leading-[1.7] text-(--ink-soft)'>{t.introduccion}</p>
      </header>
      <div className='grid gap-6 sm:grid-cols-3'>
        {t.beneficios.map((b, i) => (
          <section key={b.titulo} className='border-t border-(--line) pt-5'>
            <span aria-hidden='true' className='font-(family-name:--mono) text-[12px] text-(--teal-deep)'>
              {String(i + 1).padStart(2, '0')}
            </span>
            <h2 className='mt-3 mb-3 font-(family-name:--serif) text-[21px] leading-tight font-bold'>{b.titulo}</h2>
            <p className='m-0 text-[15px] leading-[1.7] text-(--ink-soft)'>{b.texto}</p>
          </section>
        ))}
      </div>
      <div className='grid gap-8 sm:grid-cols-2'>
        {t.secciones.map(s => (
          <section key={s.titulo} className='border-t border-(--line) pt-5'>
            <h2 className='mt-0 mb-3 font-(family-name:--serif) text-[23px] leading-tight font-bold'>{s.titulo}</h2>
            <p className='m-0 text-[16px] leading-[1.7] text-(--ink-soft)'>{s.texto}</p>
          </section>
        ))}
      </div>
      <section className='rounded-xl border border-(--line) bg-(--chat-bg) p-6 sm:p-8'>
        <h2 className='mt-0 mb-3 font-(family-name:--serif) text-[25px] font-bold'>{t.contactoTitulo}</h2>
        <p className='mt-0 mb-3 text-[16px] leading-[1.7]'>{t.contactoTexto}</p>
        <p className='mt-0 mb-5 text-[15px] leading-[1.7] text-(--ink-soft)'>{t.contactoDetalle}</p>
        <a href={`mailto:${CONTACTO}?subject=${encodeURIComponent(t.asunto)}`} className='text-(--teal-deep) underline underline-offset-4'>
          {t.contactoBoton}: {CONTACTO}
        </a>
      </section>
      <section>
        <h2 className='mt-0 mb-5 font-(family-name:--serif) text-[26px] font-bold'>{t.faqTitulo}</h2>
        <div className='border-t border-(--line)'>
          {t.preguntas.map(p => (
            <details key={p.pregunta} className='border-b border-(--line) py-4'>
              <summary className='cursor-pointer text-[16px] leading-[1.5] font-medium'>{p.pregunta}</summary>
              <p className='mt-3 mb-1 text-[15px] leading-[1.7] text-(--ink-soft)'>{p.respuesta}</p>
            </details>
          ))}
        </div>
      </section>
      <div className='flex flex-wrap items-center justify-between gap-4 text-[13px]'>
        <Link to='/fuentes' className='text-(--teal-deep) underline underline-offset-4'>
          {t.catalogo}
        </Link>
        <p className='m-0 text-(--ink-faint)'>{t.actualizado}</p>
      </div>
    </main>
  );
}
